import { LegalDocument, type LegalSectionSpec } from './components/LegalDocument';

const TERMS_SECTIONS: LegalSectionSpec[] = [
  { id: 'service', paragraphs: 2 },
  { id: 'accounts', paragraphs: 2 },
  { id: 'trial', paragraphs: 1 },
  { id: 'subscription', paragraphs: 4 },
  { id: 'cancel', paragraphs: 2 },
  { id: 'data', paragraphs: 3 },
  { id: 'use', paragraphs: 1 },
  { id: 'ip', paragraphs: 2 },
  { id: 'availability', paragraphs: 1 },
  { id: 'liability', paragraphs: 2 },
  { id: 'changes', paragraphs: 1 },
  { id: 'law', paragraphs: 1 },
  { id: 'contact', paragraphs: 1 },
];

export function TermsPage() {
  return <LegalDocument ns="legal" path="/terms" sections={TERMS_SECTIONS} />;
}
